/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {CONFIG as ɵa} from './src/types/config.token';